import React from 'react'; 
import {RenderActionIcons} from '../../DataTable';
import { isMobile } from "react-device-detect";

interface ActionButtonProps {
  row: any;
  actions: any[];
  isAllFieldVisible: boolean;
  addServiceActions?: boolean;
  index?: number;
  mergedColumns?: React.ReactNode;
  hasRowHeightOption?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  row,
  actions,
  isAllFieldVisible,
  addServiceActions = false,
  index = 0,
  mergedColumns,
  hasRowHeightOption,
}) => {
   const actionButtonWidth = isMobile ? '70px' : '140px';
  const justifyContent = addServiceActions ? 'justify-start' : 'justify-center';
  const renderActionIconWidth = addServiceActions ? { width: '90%' } : {};

  return (
    <div
      className={`flex flex-row items-center ${justifyContent}`}
      style={{
        height: '100%',
        display: 'flex',
        alignItems: hasRowHeightOption ? undefined : 'center',
        paddingTop: hasRowHeightOption ? "4px" : undefined,
        width: actionButtonWidth,
        minWidth: actionButtonWidth,
        maxWidth: actionButtonWidth,
      }}
    >

      <div className="RenderActionIcons" style={renderActionIconWidth}>
        <RenderActionIcons
          key={index}
          actions={actions}
          row={row}
          hasRowHeightOption={hasRowHeightOption}
        />
      </div>
    </div>
  );
};

export default ActionButton;
